export default __webpack_public_path__ + "static/media/Darkblade's Armbands of Secret Doors.64e6a710.jpg";